var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-modal-steps',_vm._g(_vm._b({model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}},'layout-modal-steps',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }